import { makeStyles } from '@material-ui/core/styles';
import { iconRadioOn, iconRadio } from 'assets/icons/importIcon'

const useStyles = makeStyles((theme: any) => {
  return {
    headerContent: {
        display: 'flex',
        flexDirection: "row",
        marginTop: "20px",
        paddingLeft: "20px",
        paddingRight: "20px",

    },
    bodyModalList: { 
       backgroundColor: "#FFF"
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      cursor: 'pointer'
    },
    contentTitle: {
      display: 'flex',
      textAlign: 'center',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
      marginBottom: "20px",
      margin: 'auto',
      fontSize: "16px"
    },
    contentSubTitle: {
      flex: 1,
      display: 'flex',
      textAlign: 'center',
      font: theme.custom.font.montserrat16,
      color: theme.custom.colors.primary,
      marginBottom: "20px",
      paddingLeft: "20px",
      paddingRight: "20px",
      fontSize: "15px"
  },
    typeTitle: {
      font: `700 19px/25px "Montserrat"`,
      marginBottom: "20px",
      margin: 'auto',
      fontSize: "15px",
      paddingLeft: "20px",
      paddingRight: "20px",
      color: "red"
    },
    cancelBtn: {
        display: 'flex',
        width: "150px",
        height: "45px",
        alignSelf: 'center',
        marginTop: "10px",
        color: "#000",
        justifyContent: "center",
        itemsCenter: "center",
        borderRadius: "24px",
       
    },
    confirmText: {
        flex: 1,
        justifyContent: "center",
        textAlign: "center",
        marginTop: "15px",
        font: theme.custom.font.headingMontserrat3,
    },
    viewPriceFee: {
      flexDirection: 'row',
      display: 'flex',
      marginTop: '15px',
      width: '100%',
      paddingLeft: "20px",
      paddingRight: "20px",
      marginBottom: "20px",
      justifyContent: "center"
    },
    priceMonthly: {
      width: '250px',
      marginRight: '24px',
      '& label': {
        font: theme.custom.font.paragraph3,
        color: theme.custom.colors.midBlack,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.midBlack}`,
      },
    },
    priceAnnual: {
      width: '250px',
      '& label': {
        font: theme.custom.font.paragraph3,
        color: theme.custom.colors.midBlack,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.midBlack}`,
      },
    },
    buttonContainer: {
      height: 80,
      marginRight: 20,
    },
  };
});

export default useStyles;
